export default {
  ContactPropertyManager: "Contact your Property manager about using Kolmeo",
  OverviewHeading: "Overview",
  OverviewEmptyTitle: "No tenancies found",
  OverviewEmptyContent: "Maybe you have no tenancies with Kolmeo",
  Overview: "Overview",
  Invoices: "Invoices",
  Payments: "Payments",
  Requests: "Requests",
  OffersHub: "Explore",
  VirtualAccountDetailsInformation: "These details are unique for this specific invoice.",
  LowAmount: "Amount is less than amount due",
  extraAmount: "You will need to make extra payments to fully cover the amount due.",
  VirtualAccountDetailsUnavailable: "Payment details are currently unavailable. Please reach out to your Property Manager for assistance."
};
